<template>
  <div
    class="modal hide-footer no-stacking"
    id="DeleteAuth0AccountModal"
    data-test-hook="modal-title-delete-auth0-account-modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-1 pt-1 pr-0 align-items-center">
          <h2 class="modal-title" data-test-hook="modal-heading-delete-auth0-account-modal">
            <i class="far fa-circle-exclamation colorOrange mr-1"></i>
            {{ $t('xAreYouSureYouWantToDeleteYourAccount') }}
          </h2>
          <button
            class="btn btn-icon-button btn-icon-button--gray"
            @click="closeModal()"
            data-test-hook="x-close-button-delete-auth0-account-modal"
          >
            <i class="fas fa-times" />
          </button>
        </div>

        <div class="modal-body pb-0">
          <div align-h="around" class="row">
            <div class="col" data-test-hook="modal-body-text-delete-auth0-account-modal">
              <b class="d-block">{{ $t('xReviewTheFollowingCarefully') }}</b>
              <b class="d-block mt-3 mb-1">{{ $t('xAccount') }}</b>
              {{ $t('xYourAccountWillBeDeleted') }}
              <b class="d-block mt-1 mb-1">{{ $t('xDevices') }}</b>
              {{ $t('xDevicesWillContinueToFunction') }}
              <b class="d-block mt-1 mb-1">{{ $t('xEcobeeHomesAndSharing') }}</b>
              {{ $t('xHomeWillBeRemoved') }}
              <b class="d-block mt-1 mb-1">{{ $t('xDataAndHistory') }}</b>
              {{ $t('xDataWillBeDeleted') }}
              <b class="d-block mt-1 mb-1">{{ $t('xSubscriptions') }}</b>
              {{ $t('xSubscriptionsWillBeCancelled') }}

              <a
                href="https://support.generac.com/mobilelink/s/article/How-do-I-delete-my-Mobile-Link-account"
                target="_blank"
                rel="noopener noreferrer"
                data-test-hook="modal-learn-more-link-delete-auth0-account-modal"
                class="d-block mt-4 mb-4"
              >
                {{ $t('xLearnMore') }}
                <i class="fas fa-external-link-alt" />
              </a>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex mt-2 p-0">
          <button
            type="button"
            class="btn btn-secondary my-3 ml-3"
            style="flex: 1 1 0;"
            @click="closeModal()"
            data-test-hook="cancel-button-delete-auth0-account-modal"
          >
            {{ $t('xCancel') }}
          </button>
          <button
            class="btn btn-primary my-3 mr-3"
            style="flex: 1 1 0;"
            @click="continueDeleteAccount()"
            data-test-hook="continue-button-delete-auth0-account-modal"
          >
            {{ $t('xContinue') }}
            <i class="fas fa-arrow-right fa-lg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['accountProfile'],
  methods: {
    closeModal() {
      this.trackAppInsightsEvent('DeleteAuth0AccountModal-cancel-pressed', {
        page: 'Delete Auth0 Account Modal',
        userId: this.accountProfile?.userId
      })
      document.getElementById('DeleteAuth0AccountModal').style.display = 'none'
    },
    continueDeleteAccount() {
      this.trackAppInsightsEvent('DeleteAuth0AccountModal-continue-pressed', {
        page: 'Delete Auth0 Account Modal',
        userId: this.accountProfile?.userId
      })
      this.$emit('displayConfirmDeleteAuth0AccountModal')
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 600px !important;
}
</style>
